import { useState } from "react";
import { submitEnquiry, SubmitButton, notifyError } from "./EnquiryDialog";

const field = "w-full rounded-2xl px-4 py-3 bg-[var(--surface)] border border-[var(--surface-border)] text-[var(--ink)] placeholder:text-[var(--muted)]/70 outline-none focus:border-[var(--pink)] focus:shadow-[0_0_16px_-2px_var(--glow-pink)] transition-shadow";

export const EnquiryForm = ({ kind = "contact", item, onDone, prefix = "enquiry" }) => {
  const [form, setForm] = useState({ name: "", phone: "", email: "", message: "" });
  const [loading, setLoading] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await submitEnquiry({ ...form, kind, item: item || null });
      setForm({ name: "", phone: "", email: "", message: "" });
      onDone?.();
    } catch (err) {
      notifyError(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={onSubmit} className="space-y-3 mt-2" data-testid={`${prefix}-form`}>
      <input required minLength={2} placeholder="Your name" value={form.name} onChange={set("name")} className={field} data-testid={`${prefix}-name-input`} />
      <input required type="tel" minLength={7} placeholder="Phone / WhatsApp" value={form.phone} onChange={set("phone")} className={field} data-testid={`${prefix}-phone-input`} />
      <input required type="email" placeholder="Email" value={form.email} onChange={set("email")} className={field} data-testid={`${prefix}-email-input`} />
      <textarea rows={3} placeholder="Message (optional)" value={form.message} onChange={set("message")} className={field} data-testid={`${prefix}-message-input`} />
      <SubmitButton loading={loading} label={kind === "contact" ? "Send Message" : "Confirm Enquiry"} />
    </form>
  );
};
